// extracted by mini-css-extract-plugin
export default {"canvas":"canvas__213iR"};